import React from 'react';
import Highlight from 'react-scale/components/ui/highlight';
import TaskResponseImageClassification from '../tasks/TaskResponseImageClassification';

export const instruction = 'Select the most appropriate categories for the tee shown.';

const responseText = '["Dinosaur"]';

export const responseCode = `{
  "response": {
    "taxonomies": {
      "image": ${responseText},
    },
  },
}`;

export const code = `client.createCategorizationTask({
  attachment: 'http://example.com/img.jpg',
  instruction: 'Please select the most appropriate categories for the tee shown',
  taxonomies: {
    image: {
      type: 'category',
      choices: ['Dog', 'Car', 'Dinosaur', 'House'],
    },
  },
});`;

export const response = (
  <div className="data-collection">
    <Highlight className="javascript" key="highlight-json">
      {responseCode}
    </Highlight>
  </div>
);

export const example = () => <TaskResponseImageClassification instruction={instruction} />;

export const result = (
  <TaskResponseImageClassification instruction={instruction} response={responseText} animate />
);
